<template>
  <div>
    <only-site-card :com_data="com_data">
      <template v-slot:item_edit>
        <ValidationObserver ref="observer">
          <v-container fluid>
            <v-row>
              <v-col cols="12" sm="2">
                <span class="font-weight-bold">メッセージ</span>
                <p class="red--text mini">
                  未入力の場合、コメントタブの「<strong>お店コメント</strong>」の内容で更新します。
                </p>
              </v-col>
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.comment.text"
                      :rules="items.comment.rules"
                    >
                      <v-textarea
                        ref="comment"
                        v-model="cast_prop.comment"
                        name="comment"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.comment.text"
                        rows="4"
                        outlined
                        :counter="items.comment.counter"
                        background-color="white"
                      />
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">Twitter</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12" md="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.twitter.text"
                      :rules="items.twitter.rules"
                    >
                      <v-text-field
                        ref="twitter"
                        v-model="cast_prop.twitter"
                        name="twitter"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.twitter.text"
                        persistent-hint
                        outlined
                        prefix="@"
                        hint="ユーザー名の@を除いた半角英数字と(_)5~15字"
                        :counter="items.twitter.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">Instagram</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="12" md="6">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      :name="items.instagram.text"
                      :rules="items.instagram.rules"
                    >
                      <v-text-field
                        ref="instagram"
                        v-model="cast_prop.instagram"
                        name="instagram"
                        :error-messages="errors"
                        :success="valid"
                        :label="items.instagram.text"
                        persistent-hint
                        outlined
                        hint="インスタグラムのユーザーネーム"
                        :counter="items.instagram.counter"
                        background-color="white"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">セラピスト歴</span></v-col
              >
              <v-col cols="12" sm="10">
                <v-row>
                  <v-col cols="6" sm="4" md="3">
                    <v-select
                      ref="experiences"
                      v-model="cast_prop.experiences"
                      name="experiences"
                      :items="experiencesItem"
                      :no-data-text="items.experiences.text"
                      :label="items.experiences.text"
                      success
                      outlined
                      background-color="white"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <!-- <v-divider class="mt-4 mb-10"></v-divider>
            <v-row>
              <v-col cols="12" sm="2"
                ><span class="font-weight-bold">入店日</span></v-col
              >
              <v-col cols="6" sm="3">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      ref="entry_day"
                      v-model="cast_prop.entry_day"
                      name="entry_day"
                      type="date"
                      :success="true"
                      :label="items.entry_day.text"
                      outlined
                      background-color="white"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-col>
            </v-row> -->
          </v-container>
        </ValidationObserver>
      </template>
    </only-site-card>
  </div>
</template>

<script>
import {
  set,
  ref,
  reactive,
  toRefs,
  defineComponent,
} from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";
import utilFunc from "@/common/utilFunc.js";
import selectItem from "@/common/selectItem.js";

export default defineComponent({
  props: ["com_data"],
  setup(props, ctx) {
    const CastPropsRepository = repositoryFactory.get("castProps");
    const state = reactive({
      errorElement: null,
      cast_prop: {},
      // 読み込み時データ保持(保存前比較用)
      keepData: {
        cast_prop: {},
      },
    });

    const experiencesItem = [
      { value: null, text: "--" },
      { value: 1, text: "業界未経験" },
      { value: 2, text: "3ヶ月未満" },
      { value: 3, text: "6ヶ月以上" },
      { value: 4, text: "1年以上" },
      { value: 5, text: "2年以上" },
      { value: 6, text: "3年以上" },
      { value: 7, text: "4年以上" },
      { value: 8, text: "5年以上" },
    ];

    const items = {
      "comment": {
        text: "コメント",
        rules: "max:10000",
        counter: "10000",
      },
      "twitter": {
        text: "Twitter ID",
        rules: "min:5|max:15|twitter",
        counter: "15",
      },
      "instagram": {
        text: "Instagram ID",
        rules: "max:30|instagram",
        counter: "30",
      },
      "experiences": {
        text: "セラピスト歴",
        rules: "",
        counter: "",
      },
      // "entry_day": {
      //   text: "入店日",
      //   rules: "date_format:yyyy-MM-dd",
      //   counter: "",
      // },
    };

    const init = async () => {
      // cast_propにキーを設定
      for (let key in items) {
        set(state.cast_prop, key, null);
      }
      Object.keys(props.com_data.cast_prop).forEach(function (key) {
        if (key == "experiences") {
          set(state.cast_prop, key, Number(props.com_data.cast_prop[key]));
        } else {
          set(state.cast_prop, key, props.com_data.cast_prop[key]);
        }
      });
      // 読み込み時のデータを保持(保存前に比較するため)
      state.keepData.cast_prop = Object.assign({}, state.cast_prop);
    };

    init();

    // チェック処理
    const checkValid = async () => {
      // 事前チェック処理
      state.errorElement = null;
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        let item_name = "";
        Object.keys(ctx.refs.observer.errors).forEach(function (key) {
          if (ctx.refs.observer.errors[key].length > 0) {
            item_name = key;
            return;
          }
        });
        const errorKey = utilFunc.getKeyByItemText(items, item_name);
        state.errorElement = ctx.refs[errorKey].$el;
      }
      return isValid;
    };

    const setErrorFocus = async () => {
      setTimeout(() => {
        state.errorElement.scrollIntoView({
          block: "center",
        });
      }, 300);
    };

    const save = async () => {
      // 更新前と比べて差分があれば更新処理
      if (!utilFunc.compareObject(state.keepData.cast_prop, state.cast_prop)) {
        const prop_param = [];
        for (let key in state.cast_prop) {
          prop_param.push({
            cast_id: props.com_data.cast_id,
            key: props.com_data.prefix + "__" + key,
            value: state.cast_prop[key] ?? "",
          });
        }
        await CastPropsRepository.save_all({ cast_prop: prop_param })
          .then((response) => {
            if (response.data) {
              // データ追加OK
            }
          })
          .catch((error) => {
            throw (
              "ERROR:cast_manager_wordpress.vue/save CastPropsRepository.save_all (" +
              error +
              ")"
            );
          });
      }
      return true;
    };

    return {
      props,
      selectItem,
      setting,
      items,
      experiencesItem,
      ...toRefs(state),
      checkValid,
      setErrorFocus,
      save,
    };
  },
});
</script>

<style scoped></style>
